(function () {
  'use strict';

  function init() {
    document.querySelectorAll('.bsb-anb').forEach(initSection);
  }

  function initSection(section) {
    if (typeof Swiper === 'undefined') return;

    const el = section.querySelector('.swiper');
    if (!el || el.dataset.bsbAnbInitialized) return;
    el.dataset.bsbAnbInitialized = 'true';

    const inner = section.querySelector('.bsb-anb__inner');
    const prevBtn = section.querySelector('[data-swiper-prev]');
    const nextBtn = section.querySelector('[data-swiper-next]');
    const speed = (parseFloat(el.dataset.rotationSpeed) || 5) * 1000;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const slideCount = el.querySelectorAll('.swiper-slide').length;

    const config = {
      loop: slideCount > 1,
      allowTouchMove: false,
      speed: reducedMotion ? 0 : 600,
      navigation: {
        prevEl: prevBtn,
        nextEl: nextBtn
      },
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous announcement',
        nextSlideMessage: 'Next announcement'
      },
      on: {
        slideChange(swiper) {
          const slide = swiper.slides[swiper.activeIndex];
          if (!slide || !inner) return;
          inner.style.setProperty('--bsb-anb-bg', slide.dataset.bg);
          inner.style.setProperty('--bsb-anb-text', slide.dataset.textColor);
        }
      }
    };

    if (!reducedMotion && slideCount > 1) {
      config.autoplay = {
        delay: speed,
        pauseOnMouseEnter: true,
        disableOnInteraction: false
      };
    }

    new Swiper(el, config);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
